<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto">

    <div class="position-absolute w-100 d-flex justify-content-between align-items-start p-2">
        <!-- Toggle for help request - only for messageToPrintQueue -->
        <div *ngIf="state === 'messageToPrintQueue'" class="d-flex align-items-center gap-2" style="order: 1;">
            <mat-slide-toggle 
                [(ngModel)]="isHelpRequestForPoints" 
                (change)="onHelpRequestToggleChange()"
                color="primary"
                class="small-toggle">
            </mat-slide-toggle>
            <span class="zx-text-tiny" [class.text-white]="isDarkMode">
                {{ "su-management.send-message-to-print-queue.help-request-toggle" | translate }}
            </span>
        </div>
        <span *ngIf="state !== 'messageToPrintQueue' && state !== 'sendSmsToUser'" style="order: 1;"></span>
        <!-- Close button on the right (RTL) or left (LTR) -->
        <button type="button" mat-icon-button aria-label="Close dialog" (click)="closeSuMessageToCustomerDialog()"
            class="close-icon d-flex align-items-center justify-content-center" 
            [class.text-white]="isDarkMode"
            style="order: 2;">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div
        class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 w-100 zx-min-h-modal">
        <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.zx-ltr]="!isRTL" [class.text-white]="isDarkMode">
            <span *ngIf="state === 'messageToCustomer'">
                {{ "su-management.message-to-customer" | translate }}
            </span>
            <span *ngIf="state === 'messageToHelpers'">
                {{ "su-management.send-message-to-helpers" | translate }}
            </span>
            <span *ngIf="state === 'messageToPrintQueue'">
                {{ "su-management.send-message-to-print-queue" | translate }}
            </span>
            <span *ngIf="state === 'sendSmsToUser'">
                {{ "su-management.send-sms-to-user.dialog-title" | translate:{ email: targetUserEmail } }}
            </span>
        </h4>
        
        <!-- Branch and printer info -->
        <div *ngIf="!isLoading && branch && state !== 'sendSmsToUser'" class="d-flex align-items-center gap-2 w-100 justify-content-center mt-3">
            <img [src]="getPrintingServiceIcon()" alt="printing service icon" class="d-block d-md-none zx-small-icon-size">
            <img [src]="getPrintingServiceIcon()" alt="printing service icon" class="d-none d-md-block zx-medium-icon-size">
            <img [src]="getBranchIcon()" alt="branch icon" class="d-block d-md-none zx-small-icon-size"
                 (error)="onImageError($event)">
            <img [src]="getBranchIcon()" alt="branch icon" class="d-none d-md-block zx-medium-icon-size"
                 (error)="onImageError($event)">
            <div class="d-flex align-items-center">
                <span class="d-block d-md-none h6 text-green mb-0" [class.text-white]="isDarkMode">
                    {{ getDisplayText() | translate }}
                </span>
                <span class="d-none d-md-block h4 text-green mb-0" [class.text-white]="isDarkMode">
                    {{ getDisplayText() | translate }}
                </span>
            </div>
        </div>
        
        <!-- loading -->
        <div *ngIf="isLoading" class="d-flex w-100 flex-grow-1 justify-content-center align-items-center">
            <mat-spinner class="zx-medium-icon-size" color="primary"></mat-spinner>
        </div>
        
        <!-- Main Content Area -->
        <div *ngIf="!isLoading && messageForm" class="d-flex flex-column flex-grow-1 w-100 pb-2">
            
            <!-- Form -->
            <form [formGroup]="messageForm" class="d-flex flex-column flex-grow-1 gap-3 mt-4">
                
                <!-- Toggle: Show to customer - only for messageToCustomer -->
                <div *ngIf="state !== 'messageToHelpers' && state !== 'messageToPrintQueue' && state !== 'sendSmsToUser'" class="d-flex align-items-center justify-content-between p-3 rounded-2 shadow-85">
                    <label class="d-flex align-items-center gap-2 mb-0" [class.text-white]="isDarkMode">
                        <b>{{ "su-management.message-to-customer.show-to-customer" | translate }}</b>
                    </label>
                    <mat-slide-toggle formControlName="isOn" color="primary"></mat-slide-toggle>
                </div>
                
                <!-- Title input - only for messageToCustomer -->
                <div *ngIf="state !== 'messageToHelpers' && state !== 'messageToPrintQueue' && state !== 'sendSmsToUser'" class="d-flex flex-column gap-2">
                    <label class="fw-bold" [class.text-white]="isDarkMode">
                        {{ "su-management.message-to-customer.title" | translate }}
                    </label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput formControlName="title" 
                               [class.text-white]="isDarkMode"
                               [placeholder]="'su-management.message-to-customer.title-placeholder' | translate">
                        <mat-error *ngIf="messageForm.get('title')?.hasError('required')">
                            {{ "su-management.message-to-customer.title-required" | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
                
                <!-- Spacer above content - helpers / print queue / SMS למשתמש -->
                <span *ngIf="state === 'messageToHelpers' || state === 'messageToPrintQueue' || state === 'sendSmsToUser'" class="flex-grow-1"></span>
                
                <!-- Content input -->
                <div class="d-flex flex-column gap-2">
                    <label class="fw-bold" [class.text-white]="isDarkMode">
                        {{ "su-management.message-to-customer.content" | translate }}
                    </label>
                    <mat-form-field appearance="outline" class="w-100">
                        <textarea matInput formControlName="content" 
                                  rows="5"
                                  [class.text-white]="isDarkMode"
                                  [placeholder]="'su-management.message-to-customer.content-placeholder' | translate"></textarea>
                        <mat-error *ngIf="messageForm.get('content')?.hasError('required')">
                            {{ "su-management.message-to-customer.content-required" | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
                
                <!-- Spacer below content - only for messageToHelpers and messageToPrintQueue -->
                <span *ngIf="state === 'messageToHelpers' || state === 'messageToPrintQueue' || state === 'sendSmsToUser'" class="flex-grow-1"></span>
                
                <!-- Button text input - only for messageToCustomer -->
                <div *ngIf="state !== 'messageToHelpers' && state !== 'messageToPrintQueue' && state !== 'sendSmsToUser'" class="d-flex flex-column gap-2">
                    <label class="fw-bold" [class.text-white]="isDarkMode">
                        {{ "su-management.message-to-customer.button-text" | translate }}
                    </label>
                    <mat-form-field appearance="outline" class="w-100">
                        <input matInput formControlName="buttonText" 
                               [class.text-white]="isDarkMode"
                               [placeholder]="'su-management.message-to-customer.button-text-placeholder' | translate">
                        <mat-error *ngIf="messageForm.get('buttonText')?.hasError('required')">
                            {{ "su-management.message-to-customer.button-text-required" | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
                
                <!-- Save button -->
                <div class="d-flex justify-content-center mt-3">
                    <button mat-raised-button 
                            color="primary" 
                            (click)="onSave()"
                            [disabled]="messageForm.invalid || isSaving"
                            class="rounded-pill px-5 text-white">
                        <span *ngIf="!isSaving">
                            <span *ngIf="state === 'messageToCustomer'">
                                {{ "su-management.save-changes" | translate }}
                            </span>
                            <span *ngIf="state === 'messageToHelpers'">
                                {{ "su-management.send-message-to-helpers" | translate }}
                            </span>
                            <span *ngIf="state === 'messageToPrintQueue'">
                                {{ "su-management.send-message-to-print-queue" | translate }}
                            </span>
                            <span *ngIf="state === 'sendSmsToUser'">
                                {{ "su-management.users.send-sms-to-user" | translate }}
                            </span>
                        </span>
                        <span *ngIf="isSaving" class="d-flex align-items-center justify-content-center">
                            <mat-spinner diameter="20"></mat-spinner>
                        </span>
                    </button>
                </div>
                
            </form>
            
        </div>

    </div>

</div>

